"use strict";
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var moment = require("moment");
var qs = require("qs");
function createClass(api) {
    return (function () {
        function ActivityLogInternal(data) {
            this.data = data;
        }
        Object.defineProperty(ActivityLogInternal.prototype, "start", {
            get: function () {
                return moment(new Date(this.data.start));
            },
            set: function (value) {
                this.data.start = value.valueOf();
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(ActivityLogInternal.prototype, "end", {
            get: function () {
                return moment(new Date(this.data.end));
            },
            set: function (value) {
                this.data.end = value.valueOf();
            },
            enumerable: true,
            configurable: true
        });
        ActivityLogInternal.delete = function (id) {
            return __awaiter(this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, api.req.delete("/activity_logs/" + id, api.bearerOpts)];
                        case 1:
                            _a.sent();
                            return [2];
                    }
                });
            });
        };
        ActivityLogInternal.get = function (id) {
            return __awaiter(this, void 0, void 0, function () {
                var result;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, api.req.json("/activity_logs/" + id, api.bearerOpts)];
                        case 1:
                            result = _a.sent();
                            return [2, new this(result)];
                    }
                });
            });
        };
        ActivityLogInternal.create = function (log) {
            return __awaiter(this, void 0, void 0, function () {
                var options, result;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            options = __assign({}, api.bearerOpts, { method: "POST", data: log });
                            return [4, api.req.json("/activity_logs/", options)];
                        case 1:
                            result = _a.sent();
                            return [2, new this(result)];
                    }
                });
            });
        };
        ActivityLogInternal.search = function (query) {
            return __awaiter(this, void 0, void 0, function () {
                var _this = this;
                var queryString, results;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            query.type = Array.isArray(query.type)
                                ? query.type.join(",")
                                : query.type;
                            query.trim = Array.isArray(query.trim)
                                ? query.trim.join(",")
                                : query.trim;
                            queryString = qs.stringify(query, { encode: false });
                            return [4, api.req.json("/activity_logs?" + queryString, api.bearerOpts)];
                        case 1:
                            results = _a.sent();
                            return [2, results.map(function (x) { return new _this(x); })];
                    }
                });
            });
        };
        return ActivityLogInternal;
    }());
}
exports.createClass = createClass;
exports.ActivityLog = createClass(null);
//# sourceMappingURL=activity-log.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@ifit/ifit-api-v1/out/api/activity-log/activity-log.js
// module id = 163
// module chunks = 0